import { AxiosResponse } from 'axios'

import ClientSDK from '../../../App/ClientSDK'

import { IOutOfService } from './IOutOfService'

class ServiceClient {
    static outOfServicePerson = (
        uuid: string,
        date: string
    ): Promise<IOutOfService> =>
        ClientSDK.instance()
            .put(`hr/persons/${uuid}/out-of-service`, {
                out_of_service_at: date,
            })
            .then((response: AxiosResponse): IOutOfService => {
                return response.data
            })
}

export default ServiceClient
